import { api } from "@/lib/axios";

interface BuildingProps {
  id: string;
  buildingName: string;
  address: string;
  buildingCity: string;
  buildingCountry: string;
  buildingState: string;
  buildingZip: string;
  letterIdBuilding?: string;
}

interface BuildingResponse {
  buildings: BuildingProps[];
  totalPages: number;
  totalBuildings: number;
  page: number;
}

export async function getBuildings(
  page = 1,
  pageSize = 8,
  buildingName?: string,
) {
  const queryParams = new URLSearchParams();

  queryParams.append("page", page.toString());
  queryParams.append("pageSize", pageSize.toString());

  if (buildingName !== undefined) {
    queryParams.append("buildingName", buildingName);
  }

  const { data } = await api.get<BuildingResponse>(
    `buildings?${queryParams.toString()}`,
  );

  return data;
}
